import SearchableInMobile from '@/components/app/SearchableInMobile';
import { formatApiDate } from '@/config';
import { GuideContractStatus } from '@/constants';
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col, DatePicker, Select, Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import GuideStatusInput from '../Tours/_editableComponents/GuideStatusInput';
import NTAStaffSearchField from '@/components/app/formItem/NTAStaffSearchField';
import GuideAutoComplete from '@/components/app/formItem/GuideSearchField';
import { useAppContext } from '@/contexts/AppContext';
import { isGuideOnly } from '@/services/roleService';
import NTAAccountingInput from '@/components/app/formItem/NTAAccountingInput';
type Props = {
  onSearch: (filter?: any) => void;
};
export default function GuideSearchForm({ onSearch }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { auth } = useAppContext();
  const isGuide = isGuideOnly(auth?.roleClaims);
  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ xl: 12, xxl: 10 }}
      labelAlign="left"
      colon={false}
      initialValues={{}}
      className="nta-custom-form"
      onFinish={v => {
        onSearch({
          ...v,
          tourDateFrom: formatApiDate(v.tourDateFrom) || undefined,
          tourDateTo: formatApiDate(v.tourDateTo) || undefined,
          contractAcceptanceFrom: formatApiDate(v.contractAcceptanceFrom) || undefined,
          contractAcceptanceTo: formatApiDate(v.contractAcceptanceTo) || undefined,
        });
      }}
    >
      <SearchableInMobile>
        {/* Row 1 */}
        <Form.Item noStyle name="guideId">
          <Input type="hidden" />
        </Form.Item>
        <Form.Item noStyle name="guideName">
          <Input type="hidden" />
        </Form.Item>
        <Form.Item noStyle name="superAccountingUserName">
          <Input type="hidden" />
        </Form.Item>
        <Form.Item noStyle name="superAccountingName">
          <Input type="hidden" />
        </Form.Item>
        <Form.Item noStyle name="saleStaffId">
          <Input type="hidden" />
        </Form.Item>
        <Form.Item noStyle name="saleStaffName">
          <Input type="hidden" />
        </Form.Item>

        <Row gutter={6}>
          <Col md={24} xs={24} xl={8} xxl={4}>
            <Form.Item name="tourName" label={t('guideContractList_TourName')}>
              <Input placeholder={t('guideContractList_TourName')} />
            </Form.Item>
          </Col>
          <Col md={24} xs={24} xl={16} xxl={20}>
            <Row gutter={6}>
              {isGuide ? null : (
                <Col md={12} xs={12} xl={8} xxl={6}>
                  <Form.Item name="searchGuideField" label={t('guideContractList_GuideName')}>
                    <GuideAutoComplete isIncludeDisabledGuide={false} form={form} placeholder={t('guideSearch_guideName')} />
                  </Form.Item>
                </Col>
              )}

              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="agentName" label={t('guideContractList_AGTName')}>
                  <Input placeholder={t('guideContractList_AGTName')} />
                </Form.Item>
              </Col>

              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="tourGuideStatus" label={t('guideContractList_GuideStatus')}>
                  <GuideStatusInput placeholder={t('guideContractList_GuideStatus')} />
                </Form.Item>
              </Col>

              <Col xs={12} md={12} xl={6} xxl={6}>
                <Form.Item name="tourId" label={t('guideContractList_TourID')}>
                  <Input placeholder={t('guideContractList_TourID')} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Row 2 */}
        <Row gutter={6}>
          <Col md={24} xs={24} xl={8} xxl={4}>
            <Form.Item name="tourNo" label={t('guideContractList_TourNo')}>
              <Input />
            </Form.Item>
          </Col>
          <Col md={24} xs={24} xl={16} xxl={20}>
            <Row gutter={6}>
              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="tourDateFrom" label={t('guideContractList_TourFrom')}>
                  <DatePicker className="w-100" />
                </Form.Item>
              </Col>
              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="tourDateTo" label={t('guideContractList_TourTo')}>
                  <DatePicker className="w-100" />
                </Form.Item>
              </Col>
              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="contractAcceptanceFrom" label={t('guideContractList_ContractFrom')}>
                  <DatePicker className="w-100" />
                </Form.Item>
              </Col>
              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="contractAcceptanceTo" label={t('guideContractList_ContractTo')}>
                  <DatePicker className="w-100" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        {/*  Row 3*/}
        <Row gutter={6}>
          <Col xs={12} md={12} xl={8} xxl={4}>
            <Form.Item name="tourPic" label={t('guideContractList_SalePIC')}>
              <NTAStaffSearchField form={form} idField="saleStaffId" nameField="saleStaffName" placeholder={t('guideContractList_SalePIC')} />
            </Form.Item>
          </Col>
          <Col md={24} xs={24} xl={16} xxl={20}>
            <Row gutter={6}>
              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="saleAccounting" label={t('guideContractList_SupperAccount')}>
                  <NTAAccountingInput
                    form={form}
                    idField="superAccountingUserName"
                    nameField="superAccountingName"
                    placeholder={t('guideContractList_SupperAccount')}
                  />
                </Form.Item>
              </Col>
              <Col md={12} xs={12} xl={6} xxl={6}>
                <Form.Item name="guideContractStatus" label={t('guideContractList_ContractStatus')}>
                  <Select options={GuideContractStatus.__getSelectOptions()} placeholder={t('guideContractList_ContractStatus')} />
                </Form.Item>
              </Col>
              <Col flex={1} className="search-form-action" style={{ textAlign: 'right' }}>
                <Button type="primary" htmlType="submit">
                  <SearchOutlined style={{ color: '#333' }} />
                  {t('zTable.search')}
                </Button>
                <Button type="ghost" htmlType="reset" style={{ marginLeft: 5 }}>
                  <CloseOutlined />
                  {t('zTable.reset')}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </SearchableInMobile>
    </Form>
  );
}
